module.exports = __webpack_public_path__ + "static/media/photo79.380dc094.jpg";